/**
 * panelRegistry — the data-driven map of dockable panels for the tabbed group.
 * Turns the old hardcoded `activeTab === "add" ? … : …` ternaries (group body,
 * tear ghost) into a table so a new panel is one entry, not three edits.
 *
 * Leaf module: it imports the prop-free panel BODIES, but the panels
 * themselves never import this (they depend on panelDock / DockDropPreview /
 * panelAnim only) — so there's no import cycle. Only PanelDockGroup consumes it.
 */
import type { ComponentType } from "react";

import { AddPaletteBody } from "./AddSectionPalette.js";
import { FormatPanelBody } from "./FormatToolbar.js";
import { MediaLibraryBody } from "./MediaLibraryPanel.js";
import type { DockTab } from "./panelDock.js";

export interface PanelDef {
  /** The drag-chrome-free body rendered in the group (and the tear ghost). */
  readonly Body: ComponentType;
  /** Width of this panel's tear-off ghost. */
  readonly ghostWidth: number | "max-content";
  /** Whether the tear ghost's grip uses the wide/tinted treatment (Add-style). */
  readonly ghostGripTinted: boolean;
}

export const PANEL_REGISTRY: Record<DockTab, PanelDef> = {
  add: { Body: AddPaletteBody, ghostWidth: 264, ghostGripTinted: true },
  format: {
    Body: FormatPanelBody,
    ghostWidth: "max-content",
    ghostGripTinted: false,
  },
  media: { Body: MediaLibraryBody, ghostWidth: 264, ghostGripTinted: true },
};
